<script>
  import { Router, Route } from "svelte-routing";

  // components for this layout
  import AdminNavbar from "components/Navbars/AdminNavbar.svelte";
  import Sidebar from "components/Sidebar/Sidebar.svelte";
  import HeaderStats from "components/Headers/HeaderStats.svelte";
  import FooterAdmin from "components/Footers/FooterAdmin.svelte";

  // pages for this layout
  import Dashboard from "views/admin/Dashboard.svelte";
  import Settings from "views/admin/Settings.svelte";
  import Tables from "views/admin/Tables.svelte";
  import Maps from "views/admin/Maps.svelte";
  import Timeline from "views/admin/Timeline.svelte";

  // ERPSYS
  import Banco from "../views/admin/Banco.svelte";
  import Vendedor from "../views/admin/Vendedor.svelte";
  import Moneda from "../views/admin/Moneda.svelte";
  import Atributo from "../views/admin/Atributo.svelte";
  import Empresa from "../views/admin/Empresa.svelte";
  import Sucursal from "../views/admin/Sucursal.svelte";
  import Bodega from "../views/admin/Bodega.svelte";
  import Documento from "../views/admin/Documento.svelte";
  import Cliente from "../views/admin/Cliente.svelte";
  import Role from "../views/admin/Role.svelte";
  import Usuario from "../views/admin/Usuario.svelte";
  import ImpuestoPlantilla from "../views/admin/ImpuestoPlantilla.svelte";
  import Cobrador from "../views/admin/Cobrador.svelte";
  import Operador from "../views/admin/Operador.svelte";
  import CategoriaIva from "../views/admin/CategoriaIva.svelte";
  import Proyecto from "../views/admin/Proyecto.svelte";
  import Precio from "../views/admin/Precio.svelte";
  import Proveedor from "../views/admin/Proveedor.svelte";
  import Producto from "../views/admin/Producto.svelte";
  import Delivery from "../views/admin/Delivery.svelte";
  import Transporte from "../views/admin/Transporte.svelte";
  import Vehiculo from "../views/admin/Vehiculo.svelte";
  import Escolta from "../views/admin/Escolta.svelte";
  import Corredor from "../views/admin/Corredor.svelte";
  import PilotoPeso from "../views/admin/PilotoPeso.svelte";

  export let location;
</script>

<div>
  <Sidebar location={location}/>
  <div class="relative md:ml-64 bg-blueGray-100">
    <AdminNavbar />
    <HeaderStats />
    <div class="px-4 md:px-10 mx-auto w-full -m-24">
      <Router url="admin">
        <Route path="dashboard" component="{Dashboard}" />
        <Route path="timeline" component="{Timeline}" />
        <Route path="settings" component="{Settings}" />
        <Route path="tables" component="{Tables}" />
        <Route path="maps" component="{Maps}" />
        <Route path="banco/:id" component="{Banco}" />
        <Route path="vendedor/:id" component="{Vendedor}" />
        <Route path="moneda/:id" component="{Moneda}" />
        <Route path="atributo/:id" component="{Atributo}" />
        <Route path="empresa/:id" component="{Empresa}" />
        <Route path="sucursal/:id" component="{Sucursal}" />
        <Route path="bodega/:id" component="{Bodega}" />
        <Route path="documento/:id" component="{Documento}" />
        <Route path="cliente/:id" component="{Cliente}" />
        <Route path="role/:id" component="{Role}" />
        <Route path="usuario/:id" component="{Usuario}" />
        <Route path="impuestoPlantilla/:id" component="{ImpuestoPlantilla}" />
        <Route path="cobrador/:id" component="{Cobrador}" />
        <Route path="operador/:id" component="{Operador}" />
        <Route path="categoriaIva/:id" component="{CategoriaIva}" />
        <Route path="proyecto/:id" component="{Proyecto}" />
        <Route path="precio/:id" component="{Precio}" />
        <Route path="proveedor/:id" component="{Proveedor}" />
        <Route path="producto/:id" component="{Producto}" />
        <Route path="delivery/:id" component="{Delivery}" />
        <Route path="transporte/:id" component="{Transporte}" />
        <Route path="vehiculo/:id" component="{Vehiculo}" />
        <Route path="escolta/:id" component="{Escolta}" />
        <Route path="corredor/:id" component="{Corredor}" />
        <Route path="piloto-peso/:id" component="{PilotoPeso}" />
      </Router>
      <FooterAdmin />
    </div>
  </div>
</div>
